import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem, IAPIError } from "shared/types";
import { IEventVenueBlockParams } from "Bands/types";

interface IJSONAPIVenueBlock {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIVenueBlockCollection {
  [IDataKeys.eventVenueBlock]: IJSONAPIVenueBlock;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventVenueBlockService {
  static getBlocks = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] }
  ): Promise<IJSONAPIVenueBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const venueBlocks: unknown = await APIService.get({
          path: API_ENDPOINTS.EVENT_VENUE_BLOCKS,
          data: queryParams,
        });
        resolve(venueBlocks as IJSONAPIVenueBlockCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_VENUE_BLOCKS);
        return reject(error);
      }
    });

  static getBlock = (id: string): Promise<IJSONAPIVenueBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_VENUE_BLOCK(id),
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_VENUE_BLOCK);
        return reject(error);
      }
    });

  static createBlock = (data: IEventVenueBlockParams): Promise<IJSONAPIVenueBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.EVENT_VENUE_BLOCKS,
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_EVENT_VENUE_BLOCK);
        return reject(error);
      }
    });

  static editBlock = ({
    id,
    data,
  }: {
    id: string;
    data: IEventVenueBlockParams;
  }): Promise<IJSONAPIVenueBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.EVENT_VENUE_BLOCK(id),
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_EVENT_VENUE_BLOCK);
        return reject(error);
      }
    });

  static deleteBlock = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.EVENT_VENUE_BLOCK(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_EVENT_VENUE_BLOCK);
        return reject(error);
      }
    });
}
